import {tokens} from '@commercial-helios/ui/theme'
import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import InlineWistiaVideo from '@/components/inline-wistia-video'
import type {VideoSliceFragment} from '@/graphql-types'
import {Section} from '@helios/shared/styles/grid'
import {Text} from '@helios/shared/styles/typography'
import mq from '@helios/shared/utils/media-query'

export const VideoSlice = ({
    slice,
    dataTestId,
}: {
    slice: VideoSliceFragment
    dataTestId?: string
}) => (
    <Section data-testid={dataTestId}>
        <StyledText variant="heading-large">{slice.primary.title}</StyledText>
        <InlineWistiaVideo videoId={slice.primary.video_id} thumbnail={slice.primary.thumbnail} />
    </Section>
)

const StyledText = styled(Text)`
    margin-bottom: ${tokens.spacing20};

    ${mq.min('sm')} {
        margin-bottom: ${tokens.spacing40};
    }
`

export const videoSliceFragment = graphql`
    fragment VideoSlice on PrismicSlicePageDataBodyVideo {
        __typename
        primary {
            title
            video_id
            thumbnail {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
            }
        }
    }
`
